import { router } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { useTokenStore, tokenStoreLoadingPromise } from '../../store/useTokenStore'

/** if `router.canGoBack()`, calls `router.back()`. otherwise, `router.replace(Routes.Root.route)` */
export async function routerBack() {
  if (router.canGoBack()) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    router.back()
  } else {
    await tokenStoreLoadingPromise
    const isSignedIn = useTokenStore.getState().hasTokens()
    isSignedIn ? router.replace(Routes.Main.route) : router.replace(Routes.Root.route)
  }
}
